export default {
  CUSTOMISER_TITLE: 'Customise',
};
